export default __webpack_public_path__ + "static/media/34t.44c6a92c.jpg";